import Vue from './vue-plugins';
import App from './App';
import router from './router.js';
import store from './store';

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

